import RecoveryPassForm from './RecoveryPassForm';
import './styles.styl';

export { RecoveryPassForm };
export default RecoveryPassForm;
